import { render, staticRenderFns } from "./screenMonitorItem.vue?vue&type=template&id=14ca1a96&scoped=true"
import script from "./screenMonitorItem.vue?vue&type=script&lang=js"
export * from "./screenMonitorItem.vue?vue&type=script&lang=js"
import style0 from "./screenMonitorItem.vue?vue&type=style&index=0&id=14ca1a96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ca1a96",
  null
  
)

export default component.exports